// document.addEventListener("DOMContentLoaded", function(){
//   var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
//   var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
//     return new bootstrap.Tooltip(tooltipTriggerEl)
//   })
// });

// tootip/tooltip.js
document.addEventListener("DOMContentLoaded", function () {
  // เลือกทุก element ที่ประกาศ data-bs-toggle="tooltip"
  const triggers = Array.prototype.slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );

  // เก็บอินสแตนซ์ทุกตัว และ state long-press
  const items = triggers.map((el) => {
    // อ่าน placement จาก data ถ้ามี
    const placement = el.getAttribute("data-bs-placement") || "top";

    const tt = new bootstrap.Tooltip(el, {
      trigger: "manual",       // คุม show/hide เอง
      container: "body",       // ป้องกันโดน overflow/transform ของ parent
      boundary: "window",
      placement,
      sanitize: true
    });

    return {
      el,
      tt,
      longPressTimer: null,
      isShown: false
    };
  });

  // helper: ปิด tooltip ทุกตัว ยกเว้น (optional) element ที่กำหนด
  function hideAll(exceptEl) {
    items.forEach(({ el, tt }, i) => {
      if (exceptEl && el === exceptEl) return;
      try { tt.hide(); } catch (e) {}
    });
    items.forEach((it) => (it.isShown = (exceptEl && it.el === exceptEl) ? it.isShown : false));
  }

  // helper: toggle ตัวเดียว
  function toggleOne(targetItem) {
    if (!targetItem) return;
    if (targetItem.isShown) {
      targetItem.tt.hide();
      targetItem.isShown = false;
    } else {
      hideAll(targetItem.el);
      targetItem.tt.show();
      targetItem.isShown = true;
    }
  }

  // helper: show แบบบังคับ (ใช้กับ long-press)
  function showOne(targetItem) {
    if (!targetItem) return;
    if (!targetItem.isShown) {
      hideAll(targetItem.el);
      targetItem.tt.show();
      targetItem.isShown = true;
    }
  }

  // attach events ต่อ tooltip แต่ละตัว
  items.forEach((item) => {
    const { el } = item;
    const LONG_PRESS_MS = 400;

    // ===== Desktop: hover (mouse) =====
    el.addEventListener("pointerenter", (e) => {
      if (e.pointerType === "mouse") {
        hideAll(el);
        item.tt.show();
        item.isShown = true;
      }
    });
    el.addEventListener("pointerleave", (e) => {
      if (e.pointerType === "mouse") {
        item.tt.hide();
        item.isShown = false;
      }
    });

    // ===== Mobile/Tablet: tap & long-press =====
    // click (จากทัช) = toggle
    el.addEventListener("click", (e) => {
      // บนเดสก์ท็อปก็ยังคลิกได้ (ช่วยกรณีไม่มี hover)
      toggleOne(item);
    });

    // long-press เพื่อ "แค่เปิด" (กันลั่น)
    el.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "touch" || e.pointerType === "pen") {
        clearTimeout(item.longPressTimer);
        item.longPressTimer = setTimeout(() => showOne(item), LONG_PRESS_MS);
      }
    });
    el.addEventListener("pointerup", () => clearTimeout(item.longPressTimer));
    el.addEventListener("pointercancel", () => clearTimeout(item.longPressTimer));
  });

  // ปิดเมื่อแตะนอกกรอบ
  document.addEventListener("pointerdown", (e) => {
    const clickedOnTrigger = items.some(({ el }) => el.contains(e.target));
    if (!clickedOnTrigger) hideAll();
  });

  // ปิดด้วย ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hideAll();
  });

  // ปิดเมื่อ scroll/resize/orientation
  const closeOnViewportChange = () => hideAll();
  window.addEventListener("scroll", closeOnViewportChange, { passive: true });
  window.addEventListener("resize", closeOnViewportChange);
  window.addEventListener("orientationchange", closeOnViewportChange);
});
